import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Offcanvas, Row } from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_URL } from "../Config";
import NextArrowSlider from "./NextArrowSlider";
import PrevArrowSlider from "./PrevArrowSlider";

const Testimonial = ({ cmsLits }) => {
  console.log("TestimonialTestimonialTestimonial", cmsLits.find((value) => (value.identifier == 'testimonials')))
  const [testimonial, setTestimonial] = useState(
    [
      // {
      //   content:
      //     "The data-based decisions that have been made possible with Sector-8 Ideas have allowed us to enter complex emerging markets and receive valuable and quantitative data in no time. ",
      //   icon: Images.profile1,
      //   name: "Diyana",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas was the perfect tool to get high quality insights in no time and without the high cost that traditional opinion polling carries.",
      //   icon: Images.profile2,
      //   name: "Lissa Maria",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas finally brings social media users and quantitative market research together and allow to benefit from a previously untapped resource.",
      //   icon: Images.profile3,
      //   name: "Dianne Russel",
      //   des: "",
      // },
      // {
      //   content:
      //     "The data-based decisions that have been made possible with Sector-8 Ideas have allowed us to enter complex emerging markets and receive valuable and quantitative data in no time. ",
      //   icon: Images.profile1,
      //   name: "Diyana",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas was the perfect tool to get high quality insights in no time and without the high cost that traditional opinion polling carries.",
      //   icon: Images.profile2,
      //   name: "Lissa Maria",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas finally brings social media users and quantitative market research together and allow to benefit from a previously untapped resource.",
      //   icon: Images.profile3,
      //   name: "Dianne Russel",
      //   des: "",
      // },
      // {
      //   content:
      //     "The data-based decisions that have been made possible with Sector-8 Ideas have allowed us to enter complex emerging markets and receive valuable and quantitative data in no time. ",
      //   icon: Images.profile1,
      //   name: "Diyana",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas was the perfect tool to get high quality insights in no time and without the high cost that traditional opinion polling carries.",
      //   icon: Images.profile2,
      //   name: "Lissa Maria",
      //   des: "",
      // },
      // {
      //   content:
      //     "Sector-8 Ideas finally brings social media users and quantitative market research together and allow to benefit from a previously untapped resource.",
      //   icon: Images.profile3,
      //   name: "Dianne Russel",
      //   des: "",
      // },
    ]
  );

  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(0);

  var settings = {
    dots: false,
    infinite: false,
    // centerMode: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    // afterChange: (current) => setCurrentIndex(current + 1),
    beforeChange: (_, next) => setCurrentIndex(next),
    slidesToScroll: 1,
    customPaging: (i) => (
      <img src={testimonialimgs[i].img} alt="Testimonial" className="img-fluid dotsimg" />
    ),
    nextArrow: <NextArrowSlider setNextIndex={setNextIndex} />,
    prevArrow: <PrevArrowSlider />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          //   initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  var settingstwo = {
    dots: false,
    infinite: false,
    // centerMode: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // draggable: false,
    // touchMove: false
  };


  const [testimonialimgs] = useState([
    {
      img: Images.testimonialone
    },
    {
      img: Images.testimonialtwo
    },
    {
      img: Images.testimonialthree
    },
    {
      img: Images.testimonialone
    },
    {
      img: Images.testimonialtwo
    },
    {
      img: Images.testimonialthree
    },
  ]);




  useEffect(() => {
    if (cmsLits) {
      let value = cmsLits.find((value) => (value.identifier == 'testimonials'))
      setTestimonial(value?.testimonial)
    }
  }, [cmsLits]);

  const slideTwoRef = useRef(null);
  const slideRef = useRef(null);

  useEffect(() => {
    if (nextIndex + 1 === currentIndex) {
      slideTwoRef.current.slickNext();
    } else {
      slideTwoRef.current.slickPrev();
    }
  }, [currentIndex]);



  console.log("nextIndex", slideTwoRef);

  const handleClick = (index) => {
    if (slideTwoRef.current) {
      slideTwoRef.current.slickGoTo(index);
    }
    if (slideRef.current) {
      setTimeout(() => {
        slideRef.current.slickGoTo(index);
      }, 200);
    }
  };



  // const handleClick = (i) => {    
  //   setCurrentIndex(i + 1);
  //   if (currentIndex === i) {
  //     slideRef.current.slickNext();
  //     setCurrentIndex(i);
  //   }
  //   if (nextIndex - 1 === i) {
  //     slideRef.current.slickPrev();
  //   }
  // }




  return (
    <div className="testimonial">
      <Container className="custom_container">
        <img src={Images.leftshade} alt="Left shade" className="img-fluid shadeimg leftshadeimg" />
        <img src={Images.rightshade} alt="Right shade" className="img-fluid shadeimg rightshadeimg" />
        <div className="header_sec">
          {/* <div className="d-flex align-items-center justify-content-center">
            <Button className="our_clientBtn cmn_gradientBtn">
              OUR CLIENTS
            </Button>
          </div> */}
          <Row className="mt-0">
            <Col xs={12} md={12} lg={8}>
              <p className="title-txt mb-0">
                Valuable testimonial
              </p>
            </Col>
          </Row>
        </div>
        <div className="testimonial_slider">
          <Row>
            <Col xs={12} md={12} lg={6} className="mb-5 mb-lg-0">
              <div className="testimonial_leftbox">
                {/* {
                  testimonialimgs.map((data) => (
                    <img src={data.img} alt="Testimonial" className="img-fluid activeimg" />
                  ))
                } */}
                <img src={testimonialimgs[currentIndex].img} alt="Testimonial" className="img-fluid activeimg" />
              </div>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <div className="testimonial_sliderrightbox">
                <Slider {...settings} ref={slideRef}>
                  {
                    console.log(testimonial, "testimonial")
                  }
                  {testimonial && testimonial.map((item, index) => {
                    return (
                      <div
                        className={
                          index === currentIndex
                            ? "testimonial_card"
                            : "testimonial_card"
                        }
                      >
                        <div className="content">{item.content}</div>
                        <div className="profile">
                          <img src={API_URL +
                            "/public/images/" +
                            item.image}

                            className="profile_img" />
                          <div className="profile_content">
                            <p className="name mb-0">{item.name}</p>
                            <p className="des mb-0">Manager</p>
                            {/* <p className="des mb-0">{item.des}</p> */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
                <div className="testimonial_slidertwo">
                  <Slider {...settingstwo} ref={slideTwoRef}>
                    {
                      testimonialimgs.map((testimg, i) => (
                        <button type="button" className="btn testimonial_slidertwobox" onClick={() => handleClick(i)}>
                          {/* <button type="button" className="btn testimonial_slidertwobox"> */}
                          <img src={testimg.img} alt="Testimonial" className="img-fluid dotsimg" />
                        </button>
                      ))
                    }
                  </Slider>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Testimonial;
